<template>
  <div class="signin-box">
    <h2>Please provide your token</h2>
    <p>
      To visit your attendee page, please enter your token in the field below. You have received the token in the email.
    </p>

    <form class="pure-form" @submit.prevent="signin">
      <div class="error" v-if="error">{{ error }}</div>
      <input v-model="access_token" type="password" class="pure-input" id="access_token" placeholder="Token">
      <button type="submit" class="pure-button">SIGN IN</button>
    </form>
  </div>
</template>

<script>
export default {
  name: 'Signin',
  data () {
    return {
      access_token: '',
      error: ''
    }
  },
  created () {
    this.checkSignedIn()
    this.$store.commit("loaded"),
    this.$store.commit("setAttendee", null)
    if (!this.$store.state.event.name) {
      this.$store.dispatch('fetchEvent')
    }
  },
  updated () {
    this.checkSignedIn()
  },
  methods: {
    signin () {
      this.$http.secured.post('/attendee_api/v1/signin', {access_token: this.access_token })
        .then(response => this.signinSuccessful(response))
        .catch(error => this.signinFailed(error))
    },
    signinSuccessful (response) {
      if (!response.data.csrf) {
        this.signinFailed(response)
        return
      }
      localStorage.csrf = response.data.csrf
      localStorage.signedIn = true
      this.error = ''
      this.$store.commit("loading")
      this.$router.replace('/')
    },
    signinFailed (error) {
      this.error = (error.response && error.response.data && error.response.data.error) || ''
      delete localStorage.csrf
      delete localStorage.signedIn
    },
    checkSignedIn () {
      if (localStorage.signedIn) {
        this.$router.replace('/')
      }
    },
  }
}
</script>

<style lang="scss" scoped>
  @import 'include-media/dist/_include-media.scss';

  .signin-box {
    padding: 60px 100px;
    margin: 20px auto;
    padding: 60px 8vw;
    margin: 20px auto;
  }

  h2 {
    font-family: Sarine, sans-serif;
    font-size: 40px;
    line-height: 40px;
    text-align: center;
    font-weight: 400;
  }

  p {
    text-align: center;
    font-size: 14px;
  }

  form.pure-form {
    margin: 0 auto;
    width: 400px;
    text-align: center;

    input[type=password], button {
      margin: 0 0.15em;
    }

    @include media('<=768px') {
      width: 320px;

      input[type=password], button {
        display: block;
        margin: 10px auto;
        font-size: 18px;
      }
    }

    .error {
      margin-bottom: 5px;
      color: #D8000C;
    }
  }
</style>
